import * as tokens from '../../../../../tokens/color.dark.generated.js';
export const semanticColorDark = {
    color: {
        action: {
            primary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_DARK
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_DARK
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DISABLED_DARK
                    }
                }
            },
            secondary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DISABLED_DARK
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DISABLED_DARK
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DISABLED_DARK
                    }
                }
            },
            tertiary: {
                foreground: {
                    text: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DISABLED_DARK
                    },
                    icon: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DISABLED_DARK
                    }
                },
                surface: {
                    fill: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DISABLED_DARK
                    },
                    stroke: {
                        selected: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_SELECTED_DARK,
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DEFAULT_DARK,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_HOVER_DARK,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_PRESSED_DARK,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DISABLED_DARK
                    }
                }
            }
        },
        navigation: {
            surface: {
                fill: {
                    default: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_INTERACTIVE_DARK,
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_ACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_DISABLED_DARK,
                    active: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_ACTIVE_DARK
                },
                stroke: {
                    default: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_INTERACTIVE_DARK,
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_ACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_DISABLED_DARK,
                    active: tokens.SEM_COLOR_NAVIGATION_SURFACE_STROKE_ACTIVE_DARK
                }
            },
            foreground: {
                icon: {
                    default: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_IDLE_DARK,
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_ACTIVE_DARK,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_DISABLED_DARK
                },
                text: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
                    idle: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_DISABLED_DARK
                },
                indicator: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_DARK,
                    inactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_INACTIVE_DARK
                }
            }
        },
        forms: {
            foreground: {
                icons: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DISABLED_DARK,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_ERROR_DARK
                },
                text: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_DARK,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_INTERACTIVE_DARK,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DISABLED_DARK,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_ERROR_DARK,
                    caption: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_DARK
                },
                control: {
                    selected: {
                        indicator: {
                            idle: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_IDLE_DARK,
                            interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_INTERACTIVE_DARK,
                            disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_DISABLED_DARK,
                            error: tokens.SEM_COLOR_FORMS_FOREGROUND_CONTROL_SELECTED_INDICATOR_ERROR_DARK
                        }
                    }
                },
                field: {
                    placeholder: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_PLACEHOLDER_DISABLED_DARK
                    },
                    label: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_LABEL_DISABLED_DARK
                    },
                    appendix: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_APPENDIX_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_APPENDIX_DISABLED_DARK
                    },
                    input: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_INPUT_DISABLED_DARK
                    },
                    icon: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_DISABLED_DARK,
                        error: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ICON_ERROR_DARK
                    },
                    caption: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_CAPTION_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_CAPTION_DISABLED_DARK,
                        error: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_ERROR_CAPTION_DEFAULT_DARK
                    },
                    extension: {
                        default: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_EXTENSION_DEFAULT_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_FIELD_EXTENSION_DISABLED_DARK
                    }
                },
                divider: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK
                }
            },
            surface: {
                field: {
                    stroke: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DEFAULT_DARK,
                        error: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_ERROR_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DISABLED_DARK,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_INTERACTIVE_DARK,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_READ_ONLY_DARK,
                        focus: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_FOCUS_DARK
                    },
                    fill: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_INTERACTIVE_DARK,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DISABLED_DARK,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_READ_ONLY_DARK,
                        focus: tokens.SEM_COLOR_FORMS_SURFACE_FIELD_FILL_FOCUS_DARK
                    }
                },
                control: {
                    default: {
                        stroke: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_IDLE_DARK,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_DISABLED_DARK,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_STROKE_ERROR_DARK
                        },
                        fill: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_IDLE_DARK,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_INTERACTIVE_DARK,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_DISABLED_DARK,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_DEFAULT_FILL_ERROR_DARK
                        }
                    },
                    selected: {
                        stroke: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_IDLE_DARK,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_INTERACTIVE_DARK,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_DISABLED_DARK,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_STROKE_ERROR_DARK
                        },
                        fill: {
                            idle: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_IDLE_DARK,
                            interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_INTERACTIVE_DARK,
                            disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_DISABLED_DARK,
                            error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_SELECTED_FILL_ERROR_DARK
                        }
                    }
                }
            }
        },
        ui: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_DARK,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DISABLED_DARK,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_INTERACTIVE_DARK
                },
                divider: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK
                },
                icons: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DEFAULT_DARK,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DISABLED_DARK,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_INTERACTIVE_DARK
                }
            },
            surface: {
                scrim: {
                    default: tokens.SEM_COLOR_UI_SURFACE_SCRIM_DEFAULT_DARK
                }
            }
        },
        feedback: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_DEFAULT_DARK,
                    informative: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_DARK,
                    inverted: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INVERTED_DARK
                },
                icon: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_DEFAULT_DARK,
                    success: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_SUCCESS_DARK,
                    warning: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_WARNING_DARK,
                    error: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_ICON_ERROR_DARK
                }
            },
            surface: {
                informative: tokens.SEM_COLOR_FEEDBACK_SURFACE_INFORMATIVE_DARK,
                success: tokens.SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_DARK,
                error: tokens.SEM_COLOR_FEEDBACK_SURFACE_ERROR_DARK,
                notice: tokens.SEM_COLOR_FEEDBACK_SURFACE_NOTICE_DARK
            }
        }
    }
};
//# sourceMappingURL=color.dark.js.map